import React, { useEffect, useState } from 'react'
import Navbar from "../Includes/Navbar";
import { Link } from 'react-router-dom';
import Seo from "../SEO/Seo";
import { buildBreadcrumbSchema } from "../../seo/schema";
import team4 from "../Images/img/team-4.jpg";
import team5 from "../Images/img/team-5.jpg"; 
import Footer from "../Includes/Footer";
import GeneralService from '../../services/general.service';

export default function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
    
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        setLoading(true);
        const data = await GeneralService.getStaffs();
        setStaff(data);
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, []);
    
  const getImageSource = (staff) => {
    // If staff has an image, use it
    if (staff.image) {
      return staff.image.startsWith('http')
        ? staff.image
        : `https://api.azmrehabcentre.pk/${staff.image.replace(/^\/+/, '')}`;
    }
    
    // If no image, check gender and return appropriate default
    return staff.gender === 'female' ? team4 : team5;
  };

  return (
    <>
      <Seo
        title="Our Staff Team | Azm Rehab Centre, Sargodha"
        description="Meet the compassionate and expert staff team behind Azm Rehab Centre's drug addiction and rehabilitation treatment programs in Sargodha, Punjab."
        path="/staff-team"
        jsonLd={buildBreadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Staff Team", path: "/staff-team" },
        ])}
      />
      <Navbar />
      {/* <!-- Hero Start --> */}
      <div className="container-fluid bg-primary py-5 hero-header mb-5">
        <div className="row py-3">
          <div className="col-12 text-center">
            <h1 className="display-3 text-white animated zoomIn">Our Staff Team</h1>
            <Link to="/" className="h4 text-white">Home</Link>
            <span className="text-white px-2">∕</span>
            <span className="h4 text-white" aria-current="page" style={{ textDecoration: "none", color: "gray", opacity: "0.5" }}>Staff Team</span>
          </div>
        </div>
      </div>
      {/* <!-- Hero End --> */}

      {/* <!-- Team Start --> */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-4 wow slideInUp" data-wow-delay="0.1s">
              <div className="section-title bg-light rounded h-100 p-5">
                <h5 className="position-relative d-inline-block text-primary text-uppercase">Our Staffs</h5>
                <h2 className="display-6 mb-4">Meet our compassionate and expert team of dedicated professionals.</h2>
              </div>
            </div>
            
            {loading ? (
              <div className="col-12 text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              staff.map((staffMember, index) => (
                <div
                  key={staffMember.id || index}
                  className="col-lg-4 wow slideInUp"
                  data-wow-delay={`${0.3 + index * 0.2}s`}
                >
                  <div className="team-item">
                    <div
                      className="position-relative rounded-top"
                      style={{ zIndex: "1" }}
                    >
                      <img
                        className="img-fluid rounded-top w-100"
                        src={getImageSource(staffMember)}
                        alt={staffMember.name}
                      />
                    </div>
                    <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                      <h4 className="mb-2">{staffMember.name}</h4>
                      <p className="text-primary mb-0">{staffMember.position}</p>
                      {staffMember.department && (
                        <p className="text-secondary mb-0">{staffMember.department}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <br/>
      <br/>
      {/* <!-- Team End --> */}
      <Footer/>
    </>
  )
}